import { Colors } from './types';
import { globalSystemColors } from './constants';

const white = '#fff';
const lightGrey = '#eae5e1';

export const lightColors: Colors = {
  text: {
    primary: '#2f1f19',
    secondary: '#98918a',
    basic: '#505050',
    platinum: '#7a66de',
    silver: '#888686',
    gold: '#9c8651',
    white: '#fefefe',
    tertiary: '#bcbcbc'
  },
  background: {
    primary: white,
    secondary: '#f6f4f1',
    tertiary: '#f8f8f8',
    tertiaryReverse: '#2a2a2d',
    quaternary: '#e6e6e6',
    footer: '#f8f8f8',
    mortgageLabel: 'rgba(246, 245, 244, 0.90)'
  },
  border: {
    primary: lightGrey,
    primaryReverse: '#1b1b1d',
    secondary: '#eaeaea',
    secondaryReverse: 'rgba(255, 255, 255, 0.10)'
  },
  loginButton: {
    bg: white,
    border: lightGrey,
    hoveredBorder: lightGrey
  },
  systemColors: {
    ...globalSystemColors,
    brand: '#946952',
    lightBlue: '#dae8ff',
    lightRed: '#ffe6e5',
    autumnRed: '#d93d04',
    naiveBlue: '#a5c5fc'
  },
  promotion: {
    bump: '#78c91d',
    vip: '#ff3d00',
    premium: '#ff9f2b'
  }
};
